/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LexplusKundeCategoryEnum {
  Update = 'update',
  Cancelled = 'cancelled',
  Zusatzauftrag = 'zusatzauftrag'
}
